import React from 'react';
// Keep the rest of the intelligence workspace available if GPU/WebGL initialization fails.
export default class GeoGlobeBoundary extends React.Component {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  componentDidCatch(error){
    if(process.env.NODE_ENV!=='production') console.warn('Globe rendering unavailable',error?.message);
  }
  render(){
    if(this.state.failed)return <div className="ugi-globe-placeholder" role="status"><strong>3D Earth is unavailable on this device.</strong><span>The interactive Nigeria map and all your data remain accessible.</span><button onClick={this.props.onExplore}>Open Nigeria map ↗</button></div>;
    return this.props.children;
  }
}
